import api from '@/lib/api'

const state = () => ({
  all: {
    item_count: 0,
    data: [],
  },

  currentRequest: {
    customer_request_id: -1,
    name: '',
    phone: '',
    email: '',
    notes: '',
    zipcode: '',
    referrals: [],
    blocked_ids: [],
    service: {
      service: '',
    },
    user: {
      display_name: '',
    },
  },
})

const getters = {
  all: state => state.all,
  currentRequest: state => state.currentRequest, 
}

const actions = { 
  async loadAll({ commit }, { limit, offset, search }) {

    const method = '/customer_requests'

    let params = new URLSearchParams()

    if (limit != null) params.append( 'limit', limit )
    if (offset != null) params.append( 'offset', offset )
    if (offset != null) params.append( 'search', search )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    if (result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    } 
  
     return { ...await result.json(), status: result.status, ok: false }
  },

  async loadCurrent({ commit }, customer_request_id ) {
    const result = await api.get('/customer_requests/' + customer_request_id)
    if (result.ok) {
      commit('SET_CURRENT', await result.json())
      return { ok: true }
    } 

    return { ...await result.json(), status: result.status, ok: false }
  },
  
  async updateCurrent ({ commit }, { customer_request_id, ...customer_request }) {
    const result = await api.put(`/customer_requests/${ customer_request_id }`, { customer_request })
    if (result.ok) {
      const updated = await result.json()
      commit('SET_CURRENT', updated)
      return { ok: true, updated }
    }

    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL(state, customer_requests) {
    state.all = customer_requests
  },

  SET_CURRENT: (state, customer_request) => state.currentRequest = customer_request,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}